import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';

export const QUERY_KEY = ['ARTICLE'] as const;

export const useArticle = (request) => {
  return useQuery({
    queryKey: [...QUERY_KEY, request.slug],
    queryFn: () => queryFn(request),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
